class Storage {
  strategy: string;
  constructor(strategy = 'internal') {
    this.strategy = strategy;
  }
  /**
   * @param {string} key
   * @param {any} val
   * @param {number} maxAge 存储时间：ms
   */
  set(key: string, val: any, maxAge = 0) {
    const data = {
      val,
      expires: maxAge === 0 ? 0 : Date.now() + maxAge,
    };
    window[this.strategy][key.toString()] = JSON.stringify(data);
  }
  get(key: { toString: () => string | number; }, expires = false) {
    const data = window[this.strategy][key.toString()] &&
          JSON.parse(window[this.strategy][key.toString()]);
    if (data) {
      if (data.expires === 0) {
        return expires ? data : data.val;
      }
      if (Date.now() < data.expires) {
        return expires ? data : data.val;
      }
      this.remove(key);
      return null;
    }
    return null;
  }
  remove(key: { toString: any; }) {
    delete window[this.strategy][key.toString()];
  }
}
// 全局变量
(window as any).internal = (window as any).internal || {};
const local = new Storage('localStorage');
const session = new Storage('sessionStorage');
const internal = new Storage('internal');
export {
  local,
  session,
  internal,
};
